// extracted by mini-css-extract-plugin
export default {"exandableRow":"expandable_exandableRow__UHVFY"};